import { Component, ElementRef, OnInit, ViewChild,Input } from '@angular/core';
import html2canvas from 'html2canvas';
import jspdf  from 'jspdf';  

@Component({
  selector: 'app-invoice-paper',
  templateUrl: './invoice-paper.component.html',
  styleUrls: ['./invoice-paper.component.scss']
})
export class InvoicePaperComponent implements OnInit {

  @Input() data:any;
  @Input() username:any;
  isLoading:boolean = false
  constructor() { }

  ngOnInit(): void {
    console.log(this.data)
  }
  @ViewChild('content') content: ElementRef|any

  
  public SavePDF(): void {  
    this.isLoading = true
    // let content=this.content.nativeElement;  
    // let doc = new jspdf('p', 'pt', 'a4');  
    // doc.addFont('Amiri', 'Amiri-Regular', 'normal');
    // doc.setFont('Amiri');
    // doc.html(content.innerHTML,{
    //   callback: (pdf) =>{
    //     doc.save('test.pdf'); 
    //   }
    // });  

    let DATA: any = document.getElementById('htmlData');
    html2canvas(DATA,).then((canvas) => {
     
      let fileWidth = 208;
      let fileHeight = (canvas.height * fileWidth) / canvas.width;
      const FILEURI = canvas.toDataURL('image/png');
      let PDF = new jspdf('p', 'mm', 'a4');
      let position = 0;
      PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight);
      PDF.save('payment-invoice.pdf');
    });

    setTimeout(() => {
      this.isLoading = false
    }, 1000);
  }  
}
